export const EN = {
    appDrawerTeaser: "More apps and profile",
    menuTeaser: "Open menu",
    openMenu: "Open menu",
    betaSwitch: (enabled) => enabled ? "BETA-Features enabled" : "BETA-Features disabled",
    popupMenu: {
        logout: "Logout",
        profileSettings: "Profile Settings",
        securitySettings: "Security Settings",
        feedback: "Feedback",
        imprint: "Imprint",
        privacy: "Data Privacy",
        tac: "Terms & Conditions",
        releaseNotes: "Release Notes",
    },
    appDrawer: {
        switchApps: "Switch Application",
        loggedInAs: "Logged in as",
        logout: "Logout",
        myAccount: "My Account",
        links: {
            feedback: {
                label: "Feedback",
                url: "mailto:support@21re.de",
                overThisLine: "Please write your feedback over this line",
            },
            imprint: {
                label: "Imprint",
                url: "https://21re.de/impressum?lang=en",
            },
            privacy: {
                label: "Data Privacy",
                url: "https://21re.de/datenschutz?lang=en",
            },
            tac: {
                label: "Terms & Conditions",
                url: "https://21re.de/agb?lang=en",
            },
        },
    },
    apps: {
        admin: {
            title: "Administration",
            submenus: {
                companyDefaults: "Company defaults",
                calculationMethods: "Calculation methods",
                companySettings: "Company settings",
                apiAdmin: "Manage API Tokens",
                companyUsers: "User management",
                products: "Product usage",
            },
        },
        buy: {
            title: "Buy",
            submenus: {
                contactManager: "Contacts",
                recordedOffers: "Recorded Offers",
                workspace: "Deals",
                monitors: "External monitors",
            },
        },
        "???": {
            title: "???",
            submenus: {
                "???": "???",
            },
        },
        phantomMenu: {
            title: "Phantom Menu",
            submenus: {
                content: "Content",
                content1: "Content1",
                content2: "Content2",
                content3: "Content3",
                content4: "Content4",
                content5: "Content5",
                content6: "Content6",
                content7: "Content7",
            },
        },
        account: {
            title: "My account",
            submenus: {
                profile: "Profile",
                security: "Security",
            },
        },
        portfolioAnalyse: {
            title: "Portfolio Analysis",
            submenus: {
                inProgress: "In progress",
                calculationMethod: "Calculation method",
            },
        },
        helion: {
            title: "Helion",
            submenus: {
                home: "Home",
                inProgress: "In progress",
                archive: "Archive",
                notifications: "Notifications",
                tasks: "Tasks",
                calculations: "Calculations",
                settings: "Settings",
            },
        },
        valuation: {
            title: "Valuation",
            submenus: {
                home: "Home",
            },
        },
        locationAnalytics: {
            title: "RELAS",
            submenus: {
                quickstart: "Quickstart",
                profileManager: "Profile Manager",
                locationAssessment: {
                    name: "Location Assessment",
                    modules: {
                        dashboard: "Dashboard",
                        assessment: "Scores, Ratings, Prices",
                        comparables: "Comparables",
                        marketdata: "District Data",
                        poiExplorer: "POI Explorer",
                        specialMaps: "Special Maps",
                        rentindex: "Rent Index",
                    },
                },
                locationExplorer: "Location Explorer",
                privateData: "Private Data",
                locationSelector: "Location Selector",
                ratingManager: "Rating Manager",
            },
        },
    },
    buy: {
        buy: "Buy",
        offerList: "Recorded offers",
        portfolioAnalysis: "Portfolio analysis",
        offer: "Record existing offer",
        archive: "Archive",
        offerInProgress: "Workspace",
        workflow: "My tasks",
        requests: "Publish Request",
        monitor: "Buyer monitor",
    },
    admin: {
        admin: "Administration",
        companyDefaults: "Company defaults",
        calculationMethods: "Calculation methods",
        apiTokens: "Manage API tokens",
        productUsage: "Product usage",
        companyMembers: "User management",
        companySettings: "Company settings",
        autoassign: "Auto-assign app",
    },
    sidebar: {
        settings: "Settings",
        monitors: "External monitors",
        notifications: "Notifications",
        logout: "Logout",
        feedback: "Feedback",
    },
    login: "Login",
    registration: "Registration",
    forum: "Forum",
    profile: {
        logout: "Logout",
        language: "Language",
        templates: "Templates",
        settings: "Settings",
        monitor: "External Monitors",
        statusAndInvoice: "Status & Invoice",
        deleteAccount: "Delete Account",
    },
    imprint: "Legal data",
    terms: "Terms and conditions",
    privacy: "Privacy protection",
    relativeImprintLink: "impressum?lang=en",
    relativePrivacyLink: "datenschutz?lang=en",
    relativeTermsLink: "agb?lang=en",
    wrongBrowser: "This page is optimized for: ",
    sessionExpired: {
        title: "Your session has expired!",
        paragraph: 'Click on "Login on new tab" to renew your session. After successfully logging in you will be redirected to this page.',
        goToLogin: "Login on new tab",
    },
};
//# sourceMappingURL=en.js.map